import { Element, Transforms, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, LinkElement as LinkElementType } from 'slate/types/slate';
import { LinkElement } from './components/LinkElement';

const isLink = (node: Node): node is LinkElementType => Element.isElement(node) && node.type === 'link';

const withLinks =
  (options: { deleteLink?: (a: { id?: string; documentSuperId?: string }) => void; documentId?: string } = {}) =>
  (editor: CustomEditor) => {
    const { isInline, renderElement, normalizeNode } = editor;
    const { deleteLink, documentId } = options;
    editor.isInline = (element: CustomElement) => isLink(element) || isInline(element);
    editor.renderElement = (props: RenderElementProps) => {
      if (isLink(props.element)) {
        return <LinkElement {...props} />;
      } else {
        return renderElement(props);
      }
    };

    editor.normalizeNode = (entry) => {
      const [node, path] = entry;

      if (isLink(node)) {
        if (Node.string(node) === '') {
          deleteLink?.({ id: node.id, documentSuperId: documentId });
          Transforms.unwrapNodes(editor, { at: path });
          return;
        }
      }
      normalizeNode(entry);
    };
    return editor;
  };

export default withLinks;
